export function KeyboardEventCheck(e: React.KeyboardEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLSpanElement>, callbackEnter?: Function) {
    if (e.key === 'Enter' && callbackEnter) {
        e.preventDefault();
        e.stopPropagation();
        callbackEnter();
    }
}
